import React, { useEffect, useRef, useState } from 'react';
import './CommentPopup.scss';

interface CommentPopupProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  onToggle?: (isOpen: boolean) => void; // Callback to notify parent about toggle state
}

const CommentPopup: React.FC<CommentPopupProps> = ({ trigger, children, className, onToggle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        setIsOpen(false);
        if (onToggle) {
          onToggle(false); // Notify parent that popup is closed
        }
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onToggle]);

  const handleToggle = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    if (onToggle) {
      onToggle(newState); // Notify parent about the new state
    }
  };

  return (
    <>
      <div onClick={handleToggle} className='comment-popup-trigger'>
        {trigger}
      </div>

      {isOpen && (
        <div className='comment-popup-overlay'>
          <div ref={popupRef} className={`comment-popup-box ${className || ''}`}>
            <div className='comment-popup-header'>Test Comment</div>
            <div className='comment-popup-content'>{children}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default CommentPopup;
